import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateInfo } from '../../../redux/reducer/tenant';
import Pagination from 'rc-pagination';
import { getAllTenant, deleteTenant } from '../../../api';
import { Link } from 'react-router-dom';

@connect(
  null,
  {updateInfo}
)
export default class Tenant extends Component{
  constructor(props) {
    super(props);
    this.state = {
      dataRows: [],
      totalRows: 0,
      pageSize: 10,
      current: 1
    };
  }
  componentDidMount() {
    $("#activity, #project-context").hide();
    this.mounted = true;
    this._eventHandler();
    let body = {
      currentPage: 1,
      pageSize: this.state.pageSize
    };
    this._getTenants(body);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  _getTenants = body => {
    getAllTenant(body)
      .then(res=>{
        let data = res.data || {};
        this.props.updateInfo({tenantList: data.list.slice().reverse()});
        if (this.mounted) {
          this.setState({
            dataRows: data.list,
            totalRows: data.totalRows,
            current: data.currentPage
          });
        }
      })
      .catch(err=>{
        console.log(err);
      });
  };
  _onChange = page => {
    $("#datatable [name='checkbox-inline']").prop("checked",false);
    $("#selectAll").prop("checked",false);
    let search_companyName = $("#search-companyName").val();
    let search_email = $("#search-email").val();
    let body = {
      email: search_email,
      companyName: search_companyName,
      currentPage: page,
      pageSize: this.state.pageSize
    };
    if (this.mounted) {
      this.setState({current: page});
    }
    this._getTenants(body);
  };
  _searchHandler = () => {
    let search_companyName = $("#search-companyName").val();
    let search_email = $("#search-email").val();
    let body = {
      email: search_email,
      companyName: search_companyName,
      currentPage: 1,
      pageSize: this.state.pageSize
    };
    this._getTenants(body);
  };
  _eventHandler = () => {
    $(document).on("click","#selectAll",function() {
      let curStatus = $(this).prop("checked");
      if (curStatus) {
        $("#datatable [name='checkbox-inline']").prop("checked",true);
      } else {
        $("#datatable [name='checkbox-inline']").prop("checked",false);
      }
    });
  };
  _deleteHandler = () => {
    let that = this;
    let subscriberArray = [];
    let subscriberChecked = $("#tb [name='checkbox-inline']:checked");
    $.each(subscriberChecked,function(index, item){
      subscriberArray.push($(item).attr("id"));
    });
    if (subscriberArray.length > 0) {
      $.SmartMessageBox({
        title : "Warning",
        content : "Are you sure you want to delete this tenant?",
        buttons : '[Confirm][Cancel]'
      }, function(ButtonPress){
        if (ButtonPress === "Confirm") {
          deleteTenant({ids: subscriberArray})
            .then(res => {
              $("#datatable [name='checkbox-inline']").prop("checked",false);
              $("#selectAll").prop("checked",false);
              $.bigBox({
                title : "Alert",
                content : res.message,
                color : "#739E73",
                timeout: 6000,
                icon : "fa fa-check",
                number : "Thank you"
              });
              let body = {
                currentPage: 1,
                pageSize: that.state.pageSize
              };
              that._getTenants(body);
            })
            .catch(err=>console.log(err));
        }
      });

    } else {
      $("#notSelect").modal("show");
    }
  };
  _resetAll = () => {
    $("#searchHight").find("input").val("");
  };
  _highlight = () => {
    let idSearch = $("#search-companyName").val().toUpperCase();
    let emailSearch = $("#search-email").val().toUpperCase();
    function highlight(searchStr,that) {
      let curText = $(that).text().toUpperCase();
      if(curText.indexOf(searchStr) !== -1){
        let startPoint = curText.indexOf(searchStr);
        let endPoint = startPoint+searchStr.length;
        let text = $(that).text();
        let subStr = text.slice(startPoint,endPoint);
        let startString = text.substring(0,startPoint);
        let endString = text.substring(endPoint);
        let html = startString + "<span style='color:red;'>"+ subStr +"</span>" + endString;
        $(that).html(html);
      }
    }
    $(".subscriberIN").each(function(index,el){
      highlight(idSearch,el);
    });
    $(".subscriberEmail a").each(function (index,el) {
      highlight(emailSearch,el);
    });
  };
  render() {
    let { dataRows, totalRows, current, pageSize } = this.state;
    return (
      <div>
        <div className="modal fade" id="notSelect">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title">
                  <i className="fa fa-exclamation-circle" /> &nbsp;Information Tips
                </h4>
              </div>
              <div className="modal-body">
                <div className="alert alert-block">
                  <p>Please choose datas what you want to delete</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="ribbon">
            {/*<span className="ribbon-button-alignment">*/}
              {/*<span id="refresh"*/}
                    {/*className="btn btn-ribbon"*/}
                    {/*data-action="resetWidgets"*/}
                    {/*data-title="refresh"*/}
                    {/*rel="tooltip"*/}
                    {/*data-placement="bottom"*/}
                    {/*data-original-title="<i className='text-warning fa fa-warning'></i> Warning! This will reset all your widget settings."*/}
                    {/*data-html="true">*/}
                {/*<i className="fa fa-refresh" />*/}
              {/*</span>*/}
            {/*</span>*/}
          <ol className="breadcrumb">
            <li>Tenants</li>
          </ol>
        </div>
        <div id="content">
          <div className="row">
            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-4">
              <h1 className="page-title txt-color-blueDark">
                <i className="fa fa-table fa-fw " />
                Tenants
              </h1>
            </div>
          </div>
          <section id="widget-grid" className="">
            <div className="row">
              <article className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="jarviswidget jarviswidget-color-darken"
                     id="wid-id-0"
                     data-widget-editbutton="false"
                     data-widget-deletebutton="false">
                  <header>
                    <span className="widget-icon">
                      <i className="fa fa-table" />
                    </span>
                    <h2>Tenants List</h2>
                  </header>
                  <div>
                    <div className="jarviswidget-editbox" />
                    <div className="widget-body no-padding">
                      <div className="toolbar clearfix">
                        <form id="searchHight">
                          <div className="row">
                            <div className="col-md-2 col-lg-1 col-sm-6 search-input">
                              <div className="smart-form-width smart-form client-form">
                                <label className="input">
                                  <input autoFocus="autofocus"
                                         id="search-companyName"
                                         name="clientId"
                                         className="form-control"
                                         type="text"
                                         placeholder="Tenant Name"
                                         aria-controls="dt_basic" />
                                  <b className="tooltip tooltip-top-right">
                                    <i className="fa fa-tags txt-color-teal" /> Search by Tenant Name
                                  </b>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2 col-lg-1 col-sm-6 search-input">
                              <div className="smart-form-width smart-form client-form ">
                                <label className="input">
                                  <input id="search-email"
                                         name="email"
                                         className="form-control"
                                         type="text"
                                         placeholder="Mail From"
                                         aria-controls="dt_basic" />
                                  <b className="tooltip tooltip-top-right">
                                    <i className="fa fa-envelope txt-color-teal" /> Search by Mail From
                                  </b>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2 col-sm-6" style={{minWidth: 174}}>
                              <button className="btn btn-primary mb10"
                                      onClick={this._searchHandler}
                                      type="button">
                                <i className="glyphicon glyphicon-search" /> Search
                              </button>
                              <button type="button"
                                      onClick={this._resetAll}
                                      className="btn btn-success search"
                                      style={{margin: '-10px 0 0 3px'}}>
                                Clear
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <table id="datatable"
                             className="table table-striped table-bordered table-hover smart-form"
                             width="100%">
                        <thead>
                          <tr width="2%">
                            <th>
                              <label className="checkbox">
                                <input type="checkbox"
                                       name="checkbox-inline"
                                       id="selectAll" />
                                <i />
                              </label>
                            </th>
                            <th data-hide="IN">Tenant Name</th>
                            <th>Mail From</th>
                            <th>Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody id="tb">
                        {
                          dataRows.map((row, index) => {
                            return (
                              <tr key={index}>
                                <td style={{width: 60}}>
                                  <label className="checkbox">
                                    <input type="checkbox" name="checkbox-inline" id={row.id}/>
                                    <i />
                                  </label>
                                </td>
                                <td className="subscriberIN">{row.companyName}</td>
                                <td className="subscriberEmail">{row.mailFrom}</td>
                                <td className="subscriberFlag">{row.createdOn.slice(0, 10)}</td>
                                <td className="action">
                                  <Link to={`/admin/tenant/detail/${row.id}`} className="btn btn-info">
                                    Detail
                                  </Link>
                                </td>
                              </tr>
                            );
                          })
                        }
                        </tbody>
                      </table>
                      <div className="toolbar-bottom">
                        <div className="row">
                          <div className="col-xs-4">
                            <div className='btn-group pull-left'>
                              <a className='btn btn-sm btn-primary'
                                 onClick={()=>location.reload()}
                                 href='javascript:'>
                                <span className='fa fa-refresh' />
                              </a>
                              <Link to="/admin/tenant/addTenant" className="btn btn-sm btn-primary">
                                <span className="fa fa-plus" />
                              </Link>
                              {/*<a className='btn btn-sm btn-primary btn-remove'*/}
                                 {/*onClick={this._deleteHandler}>*/}
                                {/*<span className='fa fa-trash-o' />*/}
                              {/*</a>*/}
                            </div>
                          </div>
                          <div className="col-xs-2">
                            <div className="dataTables_info" aria-live="polite">
                              <span className="text-primary totalRows">{totalRows}</span> entries
                            </div>
                          </div>
                          <div className="col-xs-6">
                            <Pagination
                              className="pull-right"
                              pageSize={pageSize}
                              defaultCurrent={1}
                              onChange={this._onChange}
                              current={current}
                              total={totalRows}
                              showLessItems
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </section>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/dashboard/model/tenant.js